
import {
  defineComponent,
  reactive,
  onMounted,
  onBeforeUnmount,
  ref, computed,
} from 'vue';
import { useStore } from 'vuex';
import ButtonIconRound from '@/components/ButtonIconRound.vue';
import AnimateScroll from '@/utils/AnimateScroll';

export default defineComponent({
  components: {
    ButtonIconRound,
  },

  setup() {
    const store = useStore();
    const logo = ref<InstanceType<typeof HTMLElement>>();
    const animateScroll = new AnimateScroll();
    const { themeUri, homeUri } = window.ioappConfig;
    const isMobile = ref(window.innerWidth <= 1400);

    const checkIfMobile = () => {
      isMobile.value = window.innerWidth <= 1400;
    };

    const header = reactive({
      top: 0,
      $el: null as null | HTMLElement,
    });

    const setHeaderPos = () => {
      const $wpAdminBar = document.querySelector('#wpadminbar');
      const $body = document.querySelector('body');
      let top = 0;

      if ($wpAdminBar) {
        top += $wpAdminBar.scrollHeight;
      }

      header.top = top;

      if ($body && header.$el) {
        $body.style.paddingTop = `${header.$el.offsetHeight}px`;
      }
    };

    const hasKlimaheldSection = computed(() => store.getters['pages/hasKlimaheldSection']);

    const scrollToKarriereheld = () => {
      animateScroll.scrollVerticalToElementById('job-market', 180);
    };

    onMounted(() => {
      header.$el = document.querySelector('header');
      if (logo.value) {
        logo.value.style.backgroundImage = `url('${themeUri}/assets/img/logo.svg')`;
      }
      window.addEventListener('resize', setHeaderPos);
      window.addEventListener('load', setHeaderPos);
      setHeaderPos();
      for (let i = 100; i < 1000; i += 100) {
        setTimeout(setHeaderPos, i);
      }

      checkIfMobile();
      window.addEventListener('resize', checkIfMobile);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', setHeaderPos);
      window.removeEventListener('load', setHeaderPos);
      window.removeEventListener('resize', checkIfMobile);
    });

    const toggleSidebar = () => {
      store.dispatch('sidebar/toggle', 'sidebar');
    };

    return {
      logo,
      header,
      themeUri,
      homeUri,
      toggleSidebar,
      hasKlimaheldSection,
      scrollToKarriereheld,
      isMobile,
    };
  },
});
